(function () {
    "use strict";

    angular.module('app').controller("CisScreeningController", CisScreeningController);

    CisScreeningController.$inject = ["controllerDecorator", "screeningService", "$scope", "cisScreening", "cisRequest", "physicalInstallation"];
    function CisScreeningController(controllerDecorator, screeningService, $scope,cisScreening, cisRequest, physicalInstallation) {

        const context = { RequestId: null };

        const vm = this;
        controllerDecorator.Decorate(vm, ["files", "dialog", "comments", "navigation"]);

        vm.AllowedLevels = $scope.codeFVMCISLevels;
      
        vm.Accept = {
            CanExecute: () => vm.request.Screening.Status === 10,
            Execute: acceptScreenings
        };

        vm.ConfirmResult = {
            CanExecute: () => vm.request.Screening.Status === 40,
            Execute: confirmResults
        };

        vm.Reject = {
            CanExecute: canRejectScreening,
            Execute: rejectScreening,
        };

        vm.SaveCisRemark = vm.Api.SaveBaseRemark;

        vm.IsRemarkActive = (screeningStatus, remark) => remark && (screeningStatus == 10 || screeningStatus == 30);

        activate();

        function activate() {
            // Parse url

            const parsed = vm.ParsePrettyUrl();
            context.RequestId = parsed.id;

            load();
        }

        function load() {
            // Load data
            cisRequest.Get(
                context.RequestId,
                r => {
                    vm.request = r.data;
                    vm.Comments.Initialize({ RequestId: context.RequestId, DossierId: null, OrganisationId: vm.request.Organisation.PublicId, ICD: vm.request.ScreeningBy });

                    physicalInstallation.GetSecuredZonesForOrganisation(
                        vm.request.Organisation.PublicId,
                        r => {
                            vm.PhysicalInstallations = r.data.filter(i => vm.request.InstallationIds.includes(i.PublicId));
                            vm.PhysicalInstallations.forEach(i => i.IsSelected = true);
                        },
                        vm.ShowError
                    );
                },
                vm.ShowError,
                () => vm.SetLoadingState(false)
            );

        }

        function acceptScreenings() {
            vm.SetLoadingState(true);
            cisScreening.Accept(
                { ScreeningIds: [vm.request.Screening.PublicId] },
                () => { load(); },
                vm.ShowError,
                () => vm.SetLoadingState(false)
            );
        }

        function confirmResults() {
            screeningService.ConfirmCisResults({ Type: "CIS", Items: [{ PublicId: vm.request.PublicId }] })
                .then(r => authenticateBeforeSigning(r))
                .catch(vm.ShowError);
        }

        /**
        * Checks if the API call succeeded and prompts the user to authenticate themselves using their eId
        * @param {Object} result the result from an API call
        */
        function authenticateBeforeSigning(result) {
            if (!CheckResultReceived(result)) {
                vm.ShowError(result);
                return;
            }

            const options = {
                onEscape: true,
                closeButton: true,
                title: vm.getTranslation("GetFasRedirectionTitle"),
                templateUrl: vm.Settings.applicationPath + "Account/ChangeFASLogin?returnurl=" + encodeURIComponent(vm.Navigator.CurrentPage)
            };
            vm.Dialog.Custom(options);
        }

        function canRejectScreening() {
            const screening = vm.request.Screening;
            const isScreeningNotCompleted = screening.Status < 40;

            if (!isScreeningNotCompleted)
                return false;

            return [screening.IdentityRemark, screening.TechnicalRemark, screening.AdministratorRemark].some(isRemarkInvalidAndComplete);

            function isRemarkInvalidAndComplete(remark) {
                return !remark.IsValid && remark.Description && remark.Description.length > 0;
            }
        }

        function rejectScreening() {
            cisScreening.Reject(
                { PublicId: vm.request.PublicId },
                () => vm.Navigator.GoToDashboard(),
                vm.ShowError,
                angular.noop
            );
        }
    }
})();
